import React, { useState, useEffect } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useWorkspace } from "../../../../contexts/WorkspaceContext";
import sourceUrl from '../../../../api/Source.api';
import { defaultSettings_button_bg_color, hoveredSettings_button_bg_color, selected_SettingsButton_bg_color } from '../../../../constants/colors';

const LanguageSettings = () => {
  const { audioLanguage, setAudioLanguage } = useWorkspace();
  const [languages, setLanguages] = useState([]);
  const theme = localStorage.getItem('theme');
  const token = localStorage.getItem('token');

  const fetchLanguages = async () => {
    try {
      const response = await fetch(`${sourceUrl}/audio/language`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      });
      const data = await response.json();
      setLanguages(data.data.data); // Assuming the response has a languages array
    } catch (error) {
      console.error('Error fetching languages:', error);
    }
  };

  useEffect(() => {
    // Fetch available languages from the API
    fetchLanguages();
  }, []);

  const handleLanguageSelect = (lang) => {
    setAudioLanguage(lang.name);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom style={{ fontSize: '16px', fontWeight: '500', width: '143px', height: '20px', marginBottom: '20px' }}>
        Select Language
      </Typography>
      <Grid container spacing={2}>
        {languages.map((lang) => (
          <Grid item key={lang.id} xs="auto">
            <Button
              variant="outlined"
              onClick={() => handleLanguageSelect(lang)}
              sx={{
                textTransform: 'none',
                backgroundColor: audioLanguage?.id === lang.id ? selected_SettingsButton_bg_color : defaultSettings_button_bg_color,
                color: theme === 'dark' ? 'white' : 'black',
                '&:hover': {
                  backgroundColor: hoveredSettings_button_bg_color,
                  borderColor:'#cac4d0'
                },
                borderColor: audioLanguage?.id === lang.id ? '#cac4d0' : 'transparent',
                m: 0.5, // Add margin for spacing
              }}
            >
              {lang.name}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LanguageSettings;

